import React from 'react'

import { Box, Flex, useMediaQuery } from '@chakra-ui/react'
import { device } from '@helpers/mediaQueryBreakpoints'

import { DesktopDevice } from './DesktopDisplay.style'

interface DesktopDisplayProps {
    media: JSX.Element
    transform?: string | string[]
    color?: string
    colorDark?: string
    colorLight?: string
    screenBorderColor?: string
    width?: string | string[]
    height?: string | string[]
    backgroundPosition?: string
    backgroundSize?: string
    objectFit?: string
    top?: string | string[]
    left?: string | string[]
}

const DesktopDisplay = ({
    media,
    transform = 'scale(0.65)',
    colorLight = 'var(--chakra-colors-grey-100)',
    color = 'var(--chakra-colors-grey-200)',
    colorDark = 'var(--chakra-colors-grey-300)',
    screenBorderColor = 'var(--chakra-colors-grey-600)',
    width = '400',
    height = '403.5px',
    top = '-68px',
    left = '-80px',
    ...rest
}: DesktopDisplayProps) => {
    const [isMobile] = useMediaQuery(device.xs)

    return isMobile ? (
        React.cloneElement(media, { boxShadow: 'lg' })
    ) : (
        <Box position="relative" h={height} w={width}>
            <Flex transform={transform} position="absolute" top={top} left={left}>
                <DesktopDevice
                    color={color}
                    colorDark={colorDark}
                    colorLight={colorLight}
                    screenBorderColor={screenBorderColor}
                >
                    <div className="device">
                        <div className="device-frame">
                            {React.cloneElement(media, { className: 'device-screen', ...rest })}
                        </div>

                        <div className="device-stand" />

                        <div className="device-stand-base" />
                    </div>
                </DesktopDevice>
            </Flex>
        </Box>
    )
}

export default DesktopDisplay
